<template lang="html">

  <section class="bottom">


    <footer class="contenedor-enlaces">

      <div class="container row-center fww aifs">

        <article class="contenedor-logo row-start">
          <img width="143px" src="/static/img/logo-blanco.png" alt="Logo iformalia">
        </article>
        <article class="datos">

          <p class="direccion" v-html="$t('contacto.boxAdress.direccion')"></p>
          <!-- <p class="direccion">C/ Fuencarral 119 3ºB, 28010 Madrid</p> -->
          <p class="telefono"><a :href="$t('contacto.boxAdress.telTo')">{{$t('contacto.boxAdress.tel')}}</a></p>
          <p class="mail"><a :href="$t('contacto.boxAdress.mailto')">{{$t('contacto.boxAdress.mail')}}</a></p>

        </article>
        <article class="rrss">

          <p v-html="$t('banner_contacto.siguenos')"></p>

          <nav class="rrss-icons row-start">
            <a target="_blank" href="https://www.linkedin.com/company/iformalia"><i class="fa fa-linkedin"></i></a>
          </nav>

        </article>
        
        <article class="newsletter">
          <newsletter></newsletter>
        </article> 


      </div>

      <div class="black-label">
        <div class="container row-between">

          <div class="row-start fww copyright">

            <a href="http://www.ocaicp.com/" target="_blank">
              <img src="/static/img/logo-veritas.png" alt="Veritas">
            </a>
            <p v-html="$t('banner_contacto.derechos')"></p>

          </div>

          <nav class="row-start">

            <router-link target="_blank" :to="$t('enlaces.politica_privacidad')">{{$t('banner_contacto.politicaPrivacidad')}}</router-link>
            <router-link target="_blank" :to="$t('enlaces.politica_cookies')">{{$t('banner_contacto.politicaCookies')}}</router-link>

          </nav>

        </div>
      </div>

    </footer>

    <div class="cover-popup-carga" v-if="isLoading">
      
      <div class="contenedor-loading row-center">
          <img src="/static/img/loading.gif" alt="Loading">    
      </div>

    </div>

  </section>

</template>

<script lang="js">

  import idioma from '@/components/view-parts/footer/idioma'
  import Newsletter from '@/components/view-parts/footer/newsletter'

  import {mapGetters} from 'vuex';

  export default  {
    name: 'app-footer',
    computed: {
      ...mapGetters(['isLoading']),
      showBanner : function(){
        let hidden = ['/contacto', '/contact', '/contatto'];
        return !(hidden.some(e => e == this.$route.path));
      }
    },
    components: {
      'idioma' : idioma,
      'newsletter' : Newsletter
    }
  }
</script>

<style scoped>

.contenedor-enlaces{
  background: #41566d;
  padding: 50px 0 0 0;
}

.contenedor-enlaces article{
  width: 25%;
  padding: 0 20px;
}

.contenedor-enlaces article:first-of-type{
  padding-left: 0;
}

.contenedor-enlaces article:last-of-type{
  padding-right: 0;
}

.datos p{
  padding-left: 25px;
  min-height: 40px;
}

.datos .direccion{
  background: url(/static/img/icon-direccion.svg) left 5px/15px no-repeat;
}

.datos .telefono{
  background: url(/static/img/icon-telefono.svg) center left/15px no-repeat;
  line-height: 40px;
}

.datos .mail{
  background: url(/static/img/icon-email.svg) center left/16px no-repeat;
  line-height: 40px;
}

.rrss-icons{
  margin-top: 10px;
}

.rrss-icons a{
  width: 25px;
  height: 25px;
  line-height: 25px;
  background: white;
  margin-right: 7px;
  display: inline-block;
  border-radius: 2px;
  padding: 0;
  text-align: center;
}

.rrss-icons a i{
  font-size: 18px;
  color: #41566d;
  height: 25px;
  line-height: 25px;
}

.black-label{
  background: #1d1d1b;
  margin-top: 50px;
  padding: 15px 0;
  position: relative;
}


.black-label:hover::before{
  transition-delay: 0;
  opacity: 1;
}

.black-label p{
  width: auto;
  margin-left: 30px;
}


nav a{
  font-size: 14px;
  color: #ececec;
  line-height: 20px;
  height: 20px;
  border-right: 1px solid #ececec;
  width: 100%;
  text-align: left;
  padding: 0 10px;
  display: inline-block;
  width: auto;
}

nav a:last-of-type{
  border: none;
  padding-right: 0;
}

.cover-popup-carga{
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 50;
  background: rgba(255,255,255,0.5);
}

.contenedor-loading{
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}

@media screen and (max-width: 900px){

  .contenedor-enlaces{
    padding-top: 20px;
  }
  
  .contenedor-logo{
    display: none;
  }

  .contenedor-enlaces article{
   width: 50%;
    padding: 0;
    padding-right: 25px;
  }

  .contenedor-enlaces article.newsletter{
    width: 100%;
    -webkit-order: -1;
    -moz-order: -1;
    -ms-order: -1;
    -o-order: -1;
    order: -1;
    margin-bottom: 20px;
  }

  .rrss{
    order: 3;
  }

  .black-label .copyright{
    -webkit-flex-direction: column;
    -moz-flex-direction: column;
    -ms-flex-direction: column;
    -o-flex-direction: column;
    flex-direction: column;
    width: 100%;
  }

  .black-label nav{
    width: 100%;
    justify-content: center;
    -webkit-justify-content: center;
  }
  footer div.container{
    max-width: 640px;
  }
}
@media screen and (max-width: 600px){
  .contenedor-enlaces article{
    width: 100%;
  }
  footer p{
    font-size: 14px!important;
    line-height: 1.57em!important;
  }

  nav a{
    padding: 0 5px;
  }
  .black-label p{
    text-align: center;
    margin-left: 0;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/parts/footer.vue